import { Tag } from "../../base_components/tag";

export function GenericEntitlement(props: {
	type: "Stripe" | "Patreon" | "Discord";
	title: string;
	payment_interval?: string;
	tag?: JSX.Element;
	details: JSX.Element;
	modify_link?: JSX.Element;
}) {
	let icon: JSX.Element;
	switch (props.type) {
		case "Stripe":
			icon = <i className="fab fa-stripe fa-2x" title="Stripe"></i>;
			break;
		case "Patreon":
			icon = <i className="fab fa-patreon" title="Patreon"></i>;
			break;
		case "Discord":
			icon = <i className="fab fa-discord fa-lg" title="discord"></i>;
			break;
	}

	return (
		<div className="flex flex-col items-center gap-2 rounded-sm bg-base-light text-sm shadow-sm sm:flex-row sm:text-base">
			<div className="flex items-center self-stretch bg-base-dark p-2 sm:min-w-[3.5rem] sm:justify-center sm:p-0">
				{icon}
			</div>
			<div className="flex w-full flex-col p-2 pt-0 pb-4 sm:p-4">
				<div className="text-md mb-2 flex flex-wrap items-center gap-2 font-bold sm:text-lg">
					{props.title}
					{props.payment_interval && (
						<Tag type="Dark">{props.payment_interval}</Tag>
					)}
					{props.tag && <>{props.tag}</>}
					<div className="ml-auto text-sm">{props.modify_link}</div>
				</div>
				<div className="flex w-full flex-col gap-4 sm:flex-row sm:text-base">
					{props.details}
				</div>
			</div>
		</div>
	);
}
